/**
 * 선택 컨트롤(체크박스·라디오) 공통 치수 — heritage 기본 16px(`size-4`) 대비 확대.
 * 모바일 WebView 터치 타깃 + 두 컨트롤의 시각 정합을 위해 한 곳에서 정한다
 * (`checkbox.tsx` · `radio-group-item.tsx` 가 공유 — 각자 하드코딩하면 드리프트).
 */
export const CONTROL_BOX = 'size-6';

/**
 * 셀렉트 트리거 룩 — heritage `SelectTrigger`(base-ui) 의 시각 사양을 옮긴 것. `SelectField` 의 compact 분기가
 * heritage 트리거 대신 `DrawerTrigger` 를 쓰므로, 두 표면이 **같은 폼 라인**(높이·보더·포커스링)을 가지려면
 * 클래스가 한 곳에서 나와야 한다. `data-size` 로 `size` prop 이 heritage 와 동일하게 동작한다.
 * (두 표면이 서로를 import 하지 않도록 여기 — 스타일 상수 모듈 — 에 둔다.)
 * ⚠️ heritage-ui 업그레이드로 트리거 룩이 바뀌면 여기도 맞춰야 드리프트가 안 생긴다.
 */
/**
 * 날짜/월 필드 트리거 룩 — `DateField`·`MonthField` 공용(두 파일에 같은 문자열이 복제돼 있던 것을 승격).
 * 셀렉트와 달리 heritage 원본이 없는 자작 트리거라 이 상수가 그대로 SSOT.
 * `data-placeholder` = 미선택(호출처가 속성으로 표기).
 */
export const DATE_TRIGGER_CLASS =
  'flex h-9 w-full items-center justify-between gap-2 rounded-md border border-input bg-transparent px-3 text-sm shadow-xs transition-colors outline-none hover:bg-accent/40 focus-visible:ring-2 focus-visible:ring-ring data-[placeholder]:text-muted-foreground';

export const SELECT_TRIGGER_CLASS =
  'flex w-fit items-center justify-between gap-1.5 rounded-md border border-input bg-transparent py-2 pr-2 pl-2.5 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-9 data-[size=sm]:h-8';
